import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlined"
import EditIcon from "@mui/icons-material/Edit"
import { Box, Tooltip, Typography } from "@mui/material"
import type { BiomeshEventResponse } from "@phc/common/gen/threatAnalyticsGen"
import { dayjsUTC } from "../../../utils/dates"
import { extraColors } from "../../../utils/theme"
import { eventStatusChipColors, eventStatusLabels } from "../../Cop/copUtils"
import { Tag } from "../../Shared/GenericTag"
import { ActionButton, CardHeader, CardRoot, CardTitle } from "./shared"

export function EventCard({
  event,
  onEdit,
  onDelete,
}: {
  event: BiomeshEventResponse
  onEdit?: () => void
  onDelete?: () => void
}) {
  const statusColor = event.status
    ? eventStatusChipColors[event.status]
    : undefined

  return (
    <CardRoot sx={{ py: 1.5, px: 2, mb: 1 }}>
      <CardHeader sx={{ mb: 0.5 }}>
        <CardTitle variant="small1Bold">{event.name}</CardTitle>
        {onEdit && (
          <Tooltip title="Edit event">
            <ActionButton size="small" onClick={onEdit}>
              <EditIcon fontSize="small" />
            </ActionButton>
          </Tooltip>
        )}
        {onDelete && (
          <Tooltip title="Delete event">
            <ActionButton size="small" onClick={onDelete}>
              <DeleteOutlineIcon fontSize="small" />
            </ActionButton>
          </Tooltip>
        )}
      </CardHeader>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
        {event.status && statusColor && (
          <Tag
            sx={{
              bgcolor: statusColor.bg,
              color: statusColor.fg,
              borderColor: statusColor.border,
            }}
          >
            <Typography variant="small1Bold" color="inherit">
              {eventStatusLabels[event.status]}
            </Typography>
          </Tag>
        )}
        {event.created_at && (
          <Typography variant="small1" sx={{ color: extraColors.hint }}>
            {dayjsUTC(event.created_at).fromNow()}
          </Typography>
        )}
        {event.updated_at && event.updated_at !== event.created_at && (
          <Typography variant="small1" sx={{ color: extraColors.hint }}>
            (edited {dayjsUTC(event.updated_at).fromNow()})
          </Typography>
        )}
      </Box>
      {event.observations && (
        <Typography
          variant="small1"
          sx={{
            color: extraColors.medium,
            mt: 0.5,
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {event.observations}
        </Typography>
      )}
      {event.resources && (
        <Typography
          variant="small1"
          sx={{
            color: extraColors.hint,
            mt: 0.5,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          Resources: {event.resources}
        </Typography>
      )}
    </CardRoot>
  )
}
